// ©2024 Austin App House. All rights reserved.
import React from "react";
import { MDBCol, MDBTable, MDBTableBody } from "mdbreact";
import HistoryCard from "./HistoryCard";

const WorkOrderHistory = ({ history = [] }) =>(
  history && history.map(historyInfo => (
    <HistoryCard key={historyInfo._id} historyInfo={historyInfo} />
  ))
)

export default WorkOrderHistory;
